module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('p', {
    staticClass: "h1",
    staticStyle: {
      "color": "#82a339"
    },
    attrs: {
      "id": "d7e1120338"
    }
  }, [_c('b', [_vm._v("CHICKEN LIVER PÂTÉ")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e1120838"
    }
  }, [_c('b', [_c('i', [_vm._v("This silky-smooth pâté is seasoned the traditional way—with thyme and brandy. For the best flavor, refrigerate at least three hours before serving.")])])]), _vm._v(" "), _c('p', {
    staticClass: "h4",
    staticStyle: {
      "color": "#496210"
    },
    attrs: {
      "id": "d7e1122138"
    }
  }, [_c('b', [_vm._v("Prep: 25 minutes plus chilling "), _c('br'), _vm._v(" Cook: 20 minutes")])]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1122938"
    }
  }, [_vm._v("2 tablespoons butter or margarine")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1123238"
    }
  }, [_vm._v("1 small onion, finely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1123538"
    }
  }, [_vm._v("1 garlic clove, finely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1123838"
    }
  }, [_vm._v("1 pound chicken livers, trimmed")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1124138"
    }
  }, [_vm._v("2 tablespoons brandy")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1124438"
    }
  }, [_vm._v("½ cup heavy or whipping cream")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1125438"
    }
  }, [_vm._v("½ teaspoon salt")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1126338"
    }
  }, [_vm._v("¼ teaspoon dried thyme")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1127338"
    }
  }, [_vm._v("¼ teaspoon ground black pepper "), _c('br'), _vm._v(" assorted crackers, toast, or thinly sliced apples")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    staticStyle: {
      "margin-top": "1.5em"
    },
    attrs: {
      "id": "d7e1128738"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("1.")])]), _vm._v(" In 10-inch skillet, melt butter over medium-high heat. Add onion and cook, stirring frequently, until tender and golden, about 10 minutes. Stir in garlic and chicken livers and cook until livers are lightly browned but still pink inside, about 5 minutes. Stir in brandy; cook 5 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e1131038"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("2.")])]), _vm._v(" In blender or in food processor with knife blade attached, puree chicken-liver mixture, cream, salt, thyme, and pepper until smooth, stopping blender occasionally and scraping down side with rubber spatula.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e1133038"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("3.")])]), _vm._v(" Spoon mixture into small bowl; cover and refrigerate at least 3 hours or up to overnight. Let stand 30 minutes at room temperature before serving. Serve with crackers, toast, or apples. Makes about 1½ cups.")]), _vm._v(" "), _c('p', {
    staticClass: "ntx",
    attrs: {
      "id": "d7e1135838"
    }
  }, [_vm._v("Each tablespoon: About 54 calories, 4g protein, 1g carbohydrate, 4g total fat (2g saturated), 92mg cholesterol, 75mg sodium.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-501feb44","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/West_9781618371621_epub_c25_r1.vue
// module id = 141
// module chunks = 0